let wakeLock: WakeLockSentinel;

//Check wake lock supported
export async function checkWakelockSupported() {
    try {
        wakeLock = await navigator.wakeLock.request("screen");
        console.log("Wake Lock is active!")
    } catch (err) {

        console.log('The Wake Lock request has failed')
    }
}

//Reacquiring a wake lock
document.addEventListener("visibilitychange", async () => {
    if (wakeLock !== null && document.visibilityState === "visible") {
        wakeLock = await navigator.wakeLock.request("screen");
    }
});

document.body.addEventListener('touchend', (e) => {
    if (!(e.target instanceof HTMLAnchorElement)) {
        e.preventDefault(),
            { passive: false }
    }
});